import { ModalService } from 'src/app/shared/services/modal.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { NavigationEnd, Router } from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  constructor(private router: Router, private authService: AuthService, private modalService: ModalService) { }

  ngOnInit() {
    this.authService.autoLogin();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.modalService.dismissAll();
      }
    });
  }
}
